import { ApiError } from '@/lib/api/http-client'

type ProfileTranslator = (key: string) => string

const messageMap: Record<string, string> = {
  'current password is incorrect': 'errors.currentPasswordIncorrect',
  'missing required parameters': 'errors.missingPasswordFields',
}

export function resolveAdminProfileErrorMessage(error: unknown, t: ProfileTranslator) {
  if (!(error instanceof ApiError)) {
    return t('errors.network')
  }

  if (error.errorCode === 'auth.account_unavailable') {
    return t('errors.accountUnavailable')
  }

  if (error.status === 401) {
    return t('errors.sessionExpired')
  }

  if (error.status === 403) {
    return t('errors.forbidden')
  }

  if (error.status >= 500) {
    return t('errors.serviceUnavailable')
  }

  const normalizedMessage = error.message.trim().toLowerCase()
  const mappedKey = messageMap[normalizedMessage]

  if (mappedKey) {
    return t(mappedKey)
  }

  return t('errors.generic')
}
